export default __webpack_public_path__ + "static/media/orange.81978ae1.svg";